export const API_URL: string =
  process.env.ROADMAP_API_URL || 'http://localhost:3010'

export type RequestArgs = {
  path: string
  method?: 'GET' | 'POST' | 'DELETE'
  body?: unknown
}

export const request = async <T>({
  path,
  method = 'GET',
  body,
}: RequestArgs): Promise<T> => {
  const response = await fetch(`${API_URL}${path}`, {
    method,
    credentials: 'include',
    headers: body ? { 'Content-Type': 'application/json' } : undefined,
    body: body ? JSON.stringify(body) : undefined,
  })

  const data = await response.json().catch(() => ({}))

  if (!response.ok) {
    const message =
      typeof data?.error === 'string' ? data.error : 'Erro inesperado'

    throw new Error(message)
  }

  return data as T
}
